import makeStyles from '@mui/styles/makeStyles';

export const FlexBox = () => {
  const style = useStyles();
  return <div className={style.root} />;
};

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
}));
